import * as sass from "./letter-heading.module.scss"

const LetterHeading = ({ title }) => {
  return (
    <>
      <p className={sass.inWhich} sx={{ variant: "text.inWhich" }}>
        In which
      </p>
      <h1
        className={sass.letterHeading}
        sx={{
          variant: "text.title",
          flex: "1 1  auto",
          px: ["2rem", "0"]
        }}
      >
        {title}
      </h1>
    </>
  )
}

export default LetterHeading
